import { CSSProperties, FC, useEffect, useRef } from "react";
import { useMapEngine, MapEngineHandle } from "./useMapEngine";

export interface MapContainerProps {
    /** Receives the engine handle once mounted, so the parent can apply configs. */
    onReady?: (handle: MapEngineHandle) => void;
    style?: CSSProperties;
}

const FILL: CSSProperties = { position: "absolute", inset: 0 };

/**
 * The single React seam between the framework-agnostic engine and React.
 * Mounts the map's container div, instantiates the engine + managers + controls
 * via {@link useMapEngine}, and hands the resulting handle to the parent.
 * Single-view (C4 slice); compare/slider compose multiple MapContainers later.
 */
const MapContainer: FC<MapContainerProps> = ({ onReady, style }) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const handle = useMapEngine(containerRef);

    useEffect(() => {
        onReady?.(handle);
        // handle identity is stable for the component's life; report once.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <div ref={containerRef} style={{ ...FILL, ...style }} className="viewer-v2-map" />;
};

export default MapContainer;
